import { render, staticRenderFns } from "./createAccountDialog.vue?vue&type=template&id=38df5e47&scoped=true"
import script from "./createAccountDialog.vue?vue&type=script&lang=js"
export * from "./createAccountDialog.vue?vue&type=script&lang=js"
import style0 from "./createAccountDialog.vue?vue&type=style&index=0&id=38df5e47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38df5e47",
  null
  
)

export default component.exports